import client_wasm from "../../ref/client.wasm?url";
import ubuntu_bold from "../../../../asset/Ubuntu-B.woff2?url";
import sp_server from "../server/sp_server.ts?worker&url";

// const client_wasm = new URL("../client.wasm", import.meta.url);
// const ubuntu_bold = new URL("../../../asset/Ubuntu-Bold.ttf", import.meta.url);

import {
    HandleEventTarget,
    KHandleEvent,
    KHandleTarget,
} from "./lib/khandler.ts";
import {
    CanvasFlag,
    CtxtOp,
    InputFlag,
    KCompositeOperation,
    KCursorStyle,
    KLineCap,
    KLineJoin,
    KTextAlign,
    KTextBaseline,
} from "./lib/kcontext.ts";
import { Path2DCompiler } from "./util/path2d.ts";
import { Ref } from "./lib/ref.ts";
import { LogLevel } from "../shared/kconsole.ts";
import { KWorkerClient, KWorkerServer } from "../shared/ksocket.ts";

const fn = async () => {
    const ref_ctx = new OffscreenCanvas(1, 1).getContext("2d");
    if (!ref_ctx) {
        alert("Browser not supported.");
        throw 1;
    }
    const ref_u32 = new Uint32Array(1);
    const encoder = new TextEncoder();
    const decoder = new TextDecoder();

    const win = window;
    const dom = document;
    const body = dom.body;
    const loc = location;
    const con = console;
    const raf = requestAnimationFrame;
    const storage = localStorage;
    const Path = Path2D;
    const Wasm = WebAssembly;
    const controller: AbortController[] = [];

    let server: Worker | null = null;
    let socket: WebSocket | null = null;
    // let socket_open_ptr = 0;
    // let socket_close_ptr = 0;
    // let socket_message_ptr = 0;
    let is_offline = false;

    const debug = (...args: any[]) => {
        if (import.meta.hot) {
            con.debug(...args);
        }
    };

    const load_font = async () => {
        const res = await fetch(
            ubuntu_bold,
        );
        const bin = await res.arrayBuffer();
        const font = new FontFace("Game", bin, {
            style: "normal",
            weight: "700",
        });
        await font.load();
        dom.fonts.add(font);
    };

    const res_font = (size: number) =>
        `700 ${size}px Game, Microsoft YaHei, sans-serif`;

    const read_bytes = (ptr: number, len: number) => {
        return u8.subarray(ptr, ptr + len);
    };

    const copy_bytes = (ptr: number, len: number) => {
        return u8.slice(ptr, ptr + len);
    };

    const read_str = (ptr: number, len: number) => {
        return decoder.decode(read_bytes(ptr, len));
    };

    const malloc_str = (str: string) => {
        const buf = encoder.encode(str);
        const len = buf.byteLength;
        const ptr = malloc(len + 4);
        u32[ptr >>> 2] = len;
        u8.set(buf, ptr + 4);
        return ptr;
    };

    const free_box_string = (ptr: number) => {
        const len = u32[ptr >>> 2];
        const str_ptr = u32[(ptr >>> 2) + 1];
        const raw_ptr = u32[(ptr >>> 2) + 2];
        const str = read_str(str_ptr, len);
        free(ptr, 12);
        free_string(raw_ptr);
        return str;
    };

    // const socket_open = () => fn_call(socket_open_ptr);
    // const socket_close = () => fn_call(socket_close_ptr);
    // const socket_message = (bin: Uint8Array) => {
    //     const len = bin.byteLength;
    //     const stack = malloc(len + 4);
    //     u8.set(bin, stack);
    //     fn_call_handler_event(socket_message_ptr, stack);
    // };

    const println = (level: LogLevel, texts: string[]) => {
        switch (level) {
            case LogLevel.Debug:
                con.debug(...texts);
                break;
            case LogLevel.Error:
                con.error(...texts);
                break;
            case LogLevel.Warn:
                con.warn(...texts);
                break;
            case LogLevel.Info:
            default:
                con.log(...texts);
                break;
        }
    };

    const i_println = (level: LogLevel, ptr: number, len: number) => {
        const text = read_str(ptr, len);
        println(level, [text]);
    };

    const i_rand_u32 = () => {
        return crypto.getRandomValues(ref_u32)[0];
    };

    const i_create_controller = (
        id: number,
    ) => {
        controller[id] = new AbortController();
    };

    const i_remove_controller = (
        id: number,
    ) => {
        controller[id].abort();
        controller[id] = null;
    };

    const i_socket_connect = (
        url_ptr: number,
        url_len: number,
        use_worker: boolean,
    ) => {
        // socket_listener_controller?.abort();
        // socket_listener_controller = new AbortController();
        is_offline = use_worker;
        // const signal = socket_listener_controller.signal;
        if (use_worker) {
            server?.terminate();
            server = new Worker(sp_server, { type: "module" });
            return;
        }
        socket = new WebSocket(read_str(url_ptr, url_len));
        socket.binaryType = "arraybuffer";
        // socket.addEventListener("open", socket_open, { signal });
        // socket.addEventListener("close", socket_close, { signal });
        // socket.addEventListener("message", (ev) => {
        //     socket_message(new Uint8Array(ev.data));
        // }, { signal });
    };

    const i_socket_disconnect = (do_close: boolean) => {
        if (do_close) {
            socket?.close();
            server?.terminate();
        }
        // socket_listener_controller?.abort();
        // socket_listener_controller = null;
        socket = null;
        server = null;
    };

    const i_socket_send = (ptr: number, len: number) => {
        if (is_offline) {
            server?.postMessage(copy_bytes(ptr, len));
        } else {
            socket?.send(read_bytes(ptr, len));
        }
    };

    const get_bind_target = (kind: KHandleTarget) => {
        switch (kind) {
            case KHandleTarget.Window:
                return win;
            case KHandleTarget.Document:
                return dom;
            case KHandleTarget.Socket:
                return socket;
            case KHandleTarget.Server:
                return server;
            default:
                debug("unreachable KHandleTarget!", kind);
                throw panic();
        }
    };

    // const f2_event_header = (ptr: number, len: number): number => {
    //     const stack = malloc(len);
    //     return 5;
    // };

    const callback_event_handler = (
        e: Event | null,
        ptr: number,
        kind: KHandleEvent,
    ) => {
        let stack = 0;
        let len = 0;
        switch (kind) {
            case KHandleEvent.Resize: {
                len += 8;
                stack = malloc(len);
                u16[stack >>> 1] = win.innerWidth;
                u16[(stack >>> 1) + 1] = win.innerHeight;
                f32[(stack >>> 2) + 1] = win.devicePixelRatio;
                break;
            }
            case KHandleEvent.MouseMove:
            case KHandleEvent.MouseDown:
            case KHandleEvent.MouseUp: {
                const event = e as MouseEvent;
                len += 5;
                stack = malloc(len);
                i16[stack >>> 1] = event.clientX;
                i16[(stack >>> 1) + 1] = event.clientY;
                u8[stack + 4] = event.button;
                break;
            }
            case KHandleEvent.TouchMove:
            case KHandleEvent.TouchStart:
            case KHandleEvent.TouchEnd: {
                const event = e as TouchEvent;
                const touches = event.changedTouches;
                const touch_len = touches.length;
                len += 1 + touch_len * 9;
                stack = malloc(len);
                u8[stack] = touch_len;
                let off = stack + 1;
                for (let i = 0; i < touch_len; i++) {
                    const touch = touches[i];
                    u8[off] = touch.identifier;
                    view.setFloat32(off + 1, touch.clientX, true);
                    view.setFloat32(off + 5, touch.clientY, true);
                    off += 9;
                }
                break;
            }
            case KHandleEvent.KeyDown:
            case KHandleEvent.KeyUp: {
                const event = e as KeyboardEvent;
                const buf = encoder.encode(event.code);
                const bytes = buf.byteLength;
                len += 2 + bytes;
                stack = malloc(len);

                const off = stack + 1;
                u8[stack] = bytes;
                u8.set(buf, off);
                u8[off + bytes] = +event.ctrlKey;
                break;
            }
            case KHandleEvent.Wheel: {
                const event = e as WheelEvent;
                len += 5;
                stack = malloc(len);
                f32[stack >>> 2] = event.deltaY;
                u8[stack + 4] = +event.ctrlKey;
                break;
            }
            case KHandleEvent.VisibilityChange: {
                len += 1;
                stack = malloc(len);
                u8[stack] = +!dom.hidden;
                break;
            }
            case KHandleEvent.SocketOpen: {
                stack = malloc(len);
                break;
            }
            case KHandleEvent.SocketClose: {
                const event = e as CloseEvent;
                len += 2;
                stack = malloc(len);
                u16[stack >>> 1] = event.code;
                break;
            }
            case KHandleEvent.SocketMessage: {
                const event = e as MessageEvent<ArrayBuffer>;
                const bin = new Uint8Array(event.data);
                const size = bin.byteLength;
                len += size;
                stack = malloc(size);
                u32[stack >>> 2] = size;
                u8.set(bin, stack + 4);
                break;
            }
            case KHandleEvent.WorkerMessage: {
                const event = e as MessageEvent<Uint8Array>;
                const data = event.data;
                const len = data.byteLength;
                if (!len) {
                    return;
                }
                switch (data[len - 1]) {
                    case KWorkerServer.Initialize: {
                        server.postMessage(
                            new Uint8Array([KWorkerClient.Connection]),
                        );
                        break;
                    }
                    case KWorkerServer.Open:
                        // socket_open();
                        break;
                    case KWorkerServer.Close:
                        // socket_close();
                        break;
                    case KWorkerServer.Message:
                        // socket_message(data.subarray(0, len - 1));
                        break;
                    default:
                        debug("unreachable data!", data);
                        panic();
                }
                break;
            }
            default:
                debug("unreachable callback KHandleEvent!", kind);
                throw panic();
        }
        const prevent = fn_call_handler_event(ptr, kind, stack, len);
        if (!prevent) return;
        e?.preventDefault();
    };

    const i_bind_event_handler = (
        ptr: number,
        kind: KHandleEvent,
        ktarget: KHandleTarget,
        flags: number,
    ) => {
        let type:
            | keyof WindowEventMap
            | keyof DocumentEventMap
            | keyof WebSocketEventMap
            | keyof WorkerEventMap;
        switch (kind) {
            case KHandleEvent.Resize:
                callback_event_handler(null, ptr, kind);
                type = "resize";
                break;
            case KHandleEvent.MouseMove:
                type = "mousemove";
                break;
            case KHandleEvent.MouseDown:
                type = "mousedown";
                break;
            case KHandleEvent.MouseUp:
                type = "mouseup";
                break;
            case KHandleEvent.TouchMove:
                type = "touchmove";
                break;
            case KHandleEvent.TouchStart:
                type = "touchstart";
                break;
            case KHandleEvent.TouchEnd:
                type = "touchend";
                break;
            case KHandleEvent.KeyDown:
                type = "keydown";
                break;
            case KHandleEvent.KeyUp:
                type = "keyup";
                break;
            case KHandleEvent.Wheel:
                type = "wheel";
                break;
            case KHandleEvent.VisibilityChange:
                type = "visibilitychange";
                break;
            case KHandleEvent.SocketOpen:
                type = "open";
                break;
            case KHandleEvent.SocketClose:
                type = "close";
                break;
            case KHandleEvent.SocketMessage:
            case KHandleEvent.WorkerMessage:
                type = "message";
                break;
            // case KHandleEvent.WorkerMessage:
            //     type = "message";
            //     break;
            default:
                debug("unreachable KHandleEvent!", kind);
                throw panic();
        }
        const target = get_bind_target(ktarget);

        target.addEventListener(
            type,
            (event) => {
                callback_event_handler(event, ptr, kind);
            },
            {
                passive: !!(flags & HandleEventTarget.IsPassive),
            },
        );
        // target = null;
    };

    const i_measure_text = (ptr: number, len: number, size: number) => {
        ref_ctx.font = res_font(size);
        return ref_ctx.measureText(read_str(ptr, len)).width;
    };

    const i_anim_frame = (ptr: number) => {
        const inner = (time: number) => {
            fn_call_anim(ptr, time);
            raf(inner);
        };
        raf(inner);
    };

    const i_location_protocol = () => {
        return malloc_str(loc.protocol);
    };

    const i_location_hostname = () => {
        return malloc_str(loc.hostname);
    };

    const i_location_reload = (ptr: number, len: number) => {
        if (!confirm(read_str(ptr, len))) return;
        loc.reload();
    };

    const i_performance_now = () => {
        return performance.now();
    };

    const i_get_local_storage = (kptr: number, klen: number) => {
        return storage.getItem(read_str(kptr, klen));
    };

    const i_set_local_storage = (
        kptr: number,
        klen: number,
        vptr: number,
        vlen: number,
    ) => {
        return storage.setItem(read_str(kptr, klen), read_str(vptr, vlen));
    };

    const i_println_styled = (
        level: LogLevel,
        ptr: number,
        len: number,
        ptr2: number,
        len2: number,
    ) => {
        const text = read_str(ptr, len);
        const style = read_str(ptr2, len2);
        println(level, [text, style]);
    };

    const i_flush = (len: number) => flush(len);

    const i_window_var_float = () => {
        return win.florrio.var_float;
    };

    const i_is_mobile = () => {
        if (navigator.userAgentData) {
            return navigator.userAgentData.mobile;
        }
        return /iPhone|iPad|Android/i.test(navigator.userAgent);
    };

    const imports: WebAssembly.Imports = /** @dict */ {
        "c": /** @dict */ {
            "a": i_println,
            "b": i_rand_u32,
            "c": i_create_controller,
            "d": i_socket_connect,
            "e": i_socket_disconnect,
            "f": i_socket_send,
            "g": i_bind_event_handler,
            "h": () => {},
            "i": i_measure_text,
            "j": i_anim_frame,
            "k": i_location_protocol,
            "l": i_location_hostname,
            "m": i_location_reload,
            "n": i_performance_now,
            "o": i_get_local_storage,
            "p": i_set_local_storage,
            "q": i_println_styled,
            "r": i_flush,
            "s": i_window_var_float,
            "t": i_is_mobile,
        },
    };

    const exports = (await Promise.all([
        Wasm.instantiateStreaming(
            fetch(client_wasm),
            imports,
        ),
        load_font(),
    ]))[0].instance.exports;

    const buffer = (exports.z as WebAssembly.Memory).buffer;
    const main = exports.a as Ref.Main;
    const fn_call = exports.b as Ref.FnCall;
    const fn_call_handler_event = exports.c as Ref.FnCallHandlerEvent;
    const fn_call_anim = exports.d as Ref.FnCallAnim;
    const panic = exports.e as Ref.Panic;
    const free = exports.f as Ref.Free;
    const free_string = exports.g as Ref.FreeString;
    const malloc = exports.h as Ref.Malloc;
    const remove_canvas = exports.i as Ref.RemoveCanvas;
    const utils_svg_to_path = exports.j as Ref.UtilsSvgToPath;
    const utils_generate_mob_image = exports.k as Ref.UtilsGenerateImage;
    const utils_generate_petal_image = exports.l as Ref.UtilsGenerateImage;

    const ptr_hex16: number =
        (exports.v as WebAssembly.Global<WebAssembly.ValueType>).value;
    const ptr_draw: number =
        (exports.y as WebAssembly.Global<WebAssembly.ValueType>).value;

    const u8 = new Uint8Array(buffer);
    // const i8 = new Int8Array(buffer);
    const u16 = new Uint16Array(buffer);
    const i16 = new Int16Array(buffer);
    const u32 = new Uint32Array(buffer);
    const f32 = new Float32Array(buffer);
    const view = new DataView(buffer);

    const path: Path2D[] = [];
    const pattern: CanvasPattern[] = [];
    const gradient: CanvasGradient[] = [];
    const ctx: Ctxt[] = [];
    const inputs: HTMLInputElement[] = [];

    // const abort = () => {
    // };

    let offset = 0;
    const hex16_char = (code: number) => u8[ptr_hex16 + code];
    const read_bool = () => !!read_u8();
    const read_u8 = () => u8[offset++];
    const read_u16 = () => {
        const u16_v = u8[offset] | u8[offset + 1] << 8;
        offset += 2;
        return u16_v;
    };
    const read_u32 = () => {
        const u32_v = view.getUint32(offset, true);
        offset += 4;
        return u32_v;
    };
    const read_f32 = () => {
        const f32_v = view.getFloat32(offset, true);
        offset += 4;
        return f32_v;
    };
    const read_text = () => {
        const len = u8[offset] | u8[offset + 1] << 8;
        const text = read_str(offset + 2, len);
        offset += 2 + len;
        return text;
    };
    const read_hex = () => {
        const r = u8[offset + 2];
        const g = u8[offset + 1];
        const b = u8[offset];
        offset += 4;
        return String.fromCharCode(
            35,
            hex16_char(r >>> 4),
            hex16_char(r & 15),
            hex16_char(g >>> 4),
            hex16_char(g & 15),
            hex16_char(b >>> 4),
            hex16_char(b & 15),
        );
    };
    const read_rgba_hex = () => {
        const r = u8[offset + 3];
        const g = u8[offset + 2];
        const b = u8[offset + 1];
        const a = u8[offset];
        offset += 4;
        return String.fromCharCode(
            35,
            hex16_char(r >>> 4),
            hex16_char(r & 15),
            hex16_char(g >>> 4),
            hex16_char(g & 15),
            hex16_char(b >>> 4),
            hex16_char(b & 15),
            hex16_char(a >>> 4),
            hex16_char(a & 15),
        );
    };
    const flush = (len: number) => {
        const end = ptr_draw + len;
        offset = ptr_draw;

        while (offset < end) {
            const op = read_u8();
            switch (op) {
                case CtxtOp.Select: {
                    // const index = read_u16();
                    // i = index;
                    read_u16();
                    break;
                }
                case CtxtOp.CreatePath: {
                    const id = read_u16();
                    path[id] = new Path();
                    break;
                }
                case CtxtOp.CreatePattern: {
                    const id = read_u16();
                    pattern[id] = ref_ctx.createPattern(
                        ctx[id].canvas,
                        "repeat",
                    );
                    break;
                }
                case CtxtOp.CreateRadialGradient: {
                    const id = read_u16();
                    const x0 = read_f32();
                    const y0 = read_f32();
                    const r0 = read_f32();
                    const x1 = read_f32();
                    const y1 = read_f32();
                    const r1 = read_f32();
                    const len = read_u8();
                    const shader = ref_ctx.createRadialGradient(
                        x0,
                        y0,
                        r0,
                        x1,
                        y1,
                        r1,
                    );
                    for (let i = 0; i < len; i++) {
                        const off = read_f32();
                        const color = read_rgba_hex();
                        shader.addColorStop(off, color);
                    }
                    gradient[id] = shader;
                    break;
                }
                case CtxtOp.CreateCanvas: {
                    const id = read_u16();
                    const width = read_u16();
                    const height = read_u16();
                    const flags = read_u8();
                    const settings: CanvasRenderingContext2DSettings = {
                        alpha: !!(flags & CanvasFlag.Alpha),
                    };
                    console.log(id, width, height, flags);
                    if (flags & CanvasFlag.Post) {
                        const canvas = dom.createElement("canvas");
                        canvas.id = "post";
                        canvas.className = "canvas";
                        canvas.width = width;
                        canvas.height = height;
                        canvas.addEventListener(
                            "contextmenu",
                            (event) => event.preventDefault(),
                        );
                        dom.querySelector("#status")?.remove();
                        body.prepend(canvas);
                        ctx[id] = canvas.getContext("2d", settings)!;
                        continue;
                    }
                    ctx[id] = new OffscreenCanvas(width, height).getContext(
                        "2d",
                        settings,
                    )!;
                    break;
                }
                case CtxtOp.RemovePath: {
                    const id = read_u16();
                    path[id] = null;
                    break;
                }
                case CtxtOp.RemoveCanvas: {
                    const id = read_u16();
                    ctx[id] = null;
                    break;
                }
                case CtxtOp.ClearCanvas: {
                    const id = read_u16();
                    const ctxt = ctx[id];
                    const cvs = ctxt.canvas;
                    const width = cvs.width;
                    const height = cvs.height;
                    ctxt.clearRect(0, 0, width, height);
                    break;
                }
                case CtxtOp.ClearRect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    ctx[id].clearRect(x, y, w, h);
                    break;
                }
                case CtxtOp.ResizeCanvas: {
                    const id = read_u16();
                    const width = read_u16();
                    const height = read_u16();
                    const cvs = ctx[id].canvas;
                    cvs.width = width;
                    cvs.height = height;
                    break;
                }

                case CtxtOp.Save: {
                    const id = read_u16();
                    ctx[id].save();
                    break;
                }
                case CtxtOp.Restore: {
                    const id = read_u16();
                    ctx[id].restore();
                    break;
                }
                case CtxtOp.Transform: {
                    const id = read_u16();
                    const a = read_f32();
                    const b = read_f32();
                    const c = read_f32();
                    const d = read_f32();
                    const e = read_f32();
                    const f = read_f32();
                    ctx[id].setTransform(a, b, c, d, e, f);
                    break;
                }
                case CtxtOp.TransformReset: {
                    const id = read_u16();
                    ctx[id].setTransform(1, 0, 0, 1, 0, 0);
                    break;
                }
                case CtxtOp.Clip: {
                    const id = read_u16();
                    const evenodd = read_bool();
                    ctx[id].clip(evenodd ? "evenodd" : "nonzero");
                    break;
                }
                case CtxtOp.ClipPath: {
                    const id = read_u16();
                    const idx = read_u16();
                    const evenodd = read_bool();
                    ctx[id].clip(path[idx], evenodd ? "evenodd" : "nonzero");
                    break;
                }

                case CtxtOp.AddPath: {
                    const id = read_u16();
                    const other = read_u16();
                    path[id].addPath(path[other]);
                    break;
                }
                case CtxtOp.BeginPath: {
                    const id = read_u16();
                    ctx[id].beginPath();
                    break;
                }

                case CtxtOp.Arc: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const radius = read_f32();
                    const start_angle = read_f32();
                    const end_angle = read_f32();
                    const counter_clockwise = read_bool();
                    ctx[id].arc(
                        x,
                        y,
                        radius,
                        start_angle,
                        end_angle,
                        counter_clockwise,
                    );
                    break;
                }
                case CtxtOp.ArcTo: {
                    const id = read_u16();
                    const x1 = read_f32();
                    const y1 = read_f32();
                    const x2 = read_f32();
                    const y2 = read_f32();
                    const radius = read_f32();
                    ctx[id].arcTo(x1, y1, x2, y2, radius);
                    break;
                }
                case CtxtOp.BezierCurveTo: {
                    const id = read_u16();
                    const cp1x = read_f32();
                    const cp1y = read_f32();
                    const cp2x = read_f32();
                    const cp2y = read_f32();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    break;
                }
                case CtxtOp.ClosePath: {
                    const id = read_u16();
                    ctx[id].closePath();
                    break;
                }
                case CtxtOp.Ellipse: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const radius_x = read_f32();
                    const radius_y = read_f32();
                    const rotation = read_f32();
                    const start_angle = read_f32();
                    const end_angle = read_f32();
                    const counter_clockwise = read_bool();
                    ctx[id].ellipse(
                        x,
                        y,
                        radius_x,
                        radius_y,
                        rotation,
                        start_angle,
                        end_angle,
                        counter_clockwise,
                    );
                    break;
                }
                case CtxtOp.LineTo: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].lineTo(x, y);
                    break;
                }
                case CtxtOp.MoveTo: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].moveTo(x, y);
                    break;
                }
                case CtxtOp.QuadraticCurveTo: {
                    const id = read_u16();
                    const cpx = read_f32();
                    const cpy = read_f32();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].quadraticCurveTo(cpx, cpy, x, y);
                    break;
                }
                case CtxtOp.Rect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    ctx[id].rect(x, y, w, h);
                    break;
                }
                case CtxtOp.RoundRect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    const radii = read_f32();
                    ctx[id].roundRect(x, y, w, h, radii);
                    break;
                }

                case CtxtOp.PathArc: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const radius = read_f32();
                    const start_angle = read_f32();
                    const end_angle = read_f32();
                    const counter_clockwise = read_bool();
                    path[id].arc(
                        x,
                        y,
                        radius,
                        start_angle,
                        end_angle,
                        counter_clockwise,
                    );
                    break;
                }
                case CtxtOp.PathArcTo: {
                    const id = read_u16();
                    const x1 = read_f32();
                    const y1 = read_f32();
                    const x2 = read_f32();
                    const y2 = read_f32();
                    const radius = read_f32();
                    path[id].arcTo(x1, y1, x2, y2, radius);
                    break;
                }
                case CtxtOp.PathBezierCurveTo: {
                    const id = read_u16();
                    const cp1x = read_f32();
                    const cp1y = read_f32();
                    const cp2x = read_f32();
                    const cp2y = read_f32();
                    const x = read_f32();
                    const y = read_f32();
                    path[id].bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    break;
                }
                case CtxtOp.PathClosePath: {
                    const id = read_u16();
                    path[id].closePath();
                    break;
                }
                case CtxtOp.PathEllipse: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const radius_x = read_f32();
                    const radius_y = read_f32();
                    const rotation = read_f32();
                    const start_angle = read_f32();
                    const end_angle = read_f32();
                    const counter_clockwise = read_bool();
                    path[id].ellipse(
                        x,
                        y,
                        radius_x,
                        radius_y,
                        rotation,
                        start_angle,
                        end_angle,
                        counter_clockwise,
                    );
                    break;
                }
                case CtxtOp.PathLineTo: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    path[id].lineTo(x, y);
                    break;
                }
                case CtxtOp.PathMoveTo: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    path[id].moveTo(x, y);
                    break;
                }
                case CtxtOp.PathQuadraticCurveTo: {
                    const id = read_u16();
                    const cpx = read_f32();
                    const cpy = read_f32();
                    const x = read_f32();
                    const y = read_f32();
                    path[id].quadraticCurveTo(cpx, cpy, x, y);
                    break;
                }
                case CtxtOp.PathRect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    path[id].rect(x, y, w, h);
                    break;
                }
                case CtxtOp.PathRoundRect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    const radii = read_f32();
                    path[id].roundRect(x, y, w, h, radii);
                    break;
                }

                // case CtxtOp.AddColorStop: {
                //     const id = read_u16();
                //     const off = read_f32();
                //     const color = read_rgba_hex();
                //     gradient[id].addColorStop(off, color);
                //     break;
                // }

                case CtxtOp.Fill: {
                    const id = read_u16();
                    ctx[id].fill();
                    break;
                }
                case CtxtOp.FillPath: {
                    const id = read_u16();
                    const idx = read_u16();
                    ctx[id].fill(path[idx]);
                    break;
                }
                case CtxtOp.FillRect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    ctx[id].fillRect(x, y, w, h);
                    break;
                }
                case CtxtOp.FillText: {
                    const id = read_u16();
                    const text = read_text();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].fillText(text, x, y);
                    break;
                }
                case CtxtOp.FillStyle: {
                    const id = read_u16();
                    const hex = read_hex();
                    ctx[id].fillStyle = hex;
                    break;
                }
                case CtxtOp.FillPattern: {
                    const id = read_u16();
                    const idx = read_u16();
                    ctx[id].fillStyle = pattern[idx];
                    break;
                }
                case CtxtOp.FillGradient: {
                    const id = read_u16();
                    const idx = read_u16();
                    ctx[id].fillStyle = gradient[idx];
                    break;
                }

                case CtxtOp.Stroke: {
                    const id = read_u16();
                    ctx[id].stroke();
                    break;
                }
                case CtxtOp.StrokePath: {
                    const id = read_u16();
                    const idx = read_u16();
                    ctx[id].stroke(path[idx]);
                    break;
                }
                case CtxtOp.StrokeRect: {
                    const id = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const w = read_f32();
                    const h = read_f32();
                    ctx[id].strokeRect(x, y, w, h);
                    break;
                }
                case CtxtOp.StrokeText: {
                    const id = read_u16();
                    const text = read_text();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].strokeText(text, x, y);
                    break;
                }
                case CtxtOp.StrokeStyle: {
                    const id = read_u16();
                    const hex = read_hex();
                    ctx[id].strokeStyle = hex;
                    break;
                }

                case CtxtOp.DrawText: {
                    const id = read_u16();
                    const text = read_text();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].strokeText(text, x, y);
                    ctx[id].fillText(text, x, y);
                    break;
                }
                case CtxtOp.DrawImageStatic: {
                    const id = read_u16();
                    const index = read_u16();
                    ctx[id].drawImage(ctx[index].canvas, 0, 0);
                    break;
                }
                case CtxtOp.DrawImage: {
                    const id = read_u16();
                    const index = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    ctx[id].drawImage(ctx[index].canvas, x, y);
                    break;
                }
                case CtxtOp.DrawImageDwDh: {
                    const id = read_u16();
                    const index = read_u16();
                    const x = read_f32();
                    const y = read_f32();
                    const dw = read_f32();
                    const dh = read_f32();
                    ctx[id].drawImage(
                        ctx[index].canvas,
                        x,
                        y,
                        dw,
                        dh,
                    );
                    break;
                }
                case CtxtOp.DrawImageDxDyDwDh: {
                    const id = read_u16();
                    const index = read_u16();
                    const sx = read_f32();
                    const sy = read_f32();
                    const sw = read_f32();
                    const sh = read_f32();
                    const dx = read_f32();
                    const dy = read_f32();
                    const dw = read_f32();
                    const dh = read_f32();
                    ctx[id].drawImage(
                        ctx[index].canvas,
                        sx,
                        sy,
                        sw,
                        sh,
                        dx,
                        dy,
                        dw,
                        dh,
                    );
                    break;
                }

                case CtxtOp.ImageSmoothing: {
                    const id = read_u16();
                    const smooth = read_bool();
                    ctx[id].imageSmoothingEnabled = smooth;
                    break;
                }
                case CtxtOp.GlobalAlpha: {
                    const id = read_u16();
                    const alpha = read_f32();
                    ctx[id].globalAlpha = alpha;
                    break;
                }
                case CtxtOp.LineWidth: {
                    const id = read_u16();
                    const width = read_f32();
                    ctx[id].lineWidth = width;
                    break;
                }
                case CtxtOp.TextSize: {
                    const id = read_u16();
                    const size = read_f32();
                    ctx[id].font = res_font(size);
                    break;
                }
                case CtxtOp.MiterLimit: {
                    const id = read_u16();
                    const miter_limit = read_f32();
                    ctx[id].miterLimit = miter_limit;
                    break;
                }

                case CtxtOp.TextAlign: {
                    const id = read_u16();
                    const kind: KTextAlign = read_u8();
                    let align: CanvasTextAlign;
                    switch (kind) {
                        case KTextAlign.Center:
                            align = "center";
                            break;
                        case KTextAlign.End:
                            align = "end";
                            break;
                        case KTextAlign.Left:
                            align = "left";
                            break;
                        case KTextAlign.Right:
                            align = "right";
                            break;
                        case KTextAlign.Start:
                            align = "start";
                            break;
                        default:
                            debug("unreachable KTextAlign!", kind);
                            throw panic();
                    }
                    ctx[id].textAlign = align;
                    break;
                }
                case CtxtOp.TextBaseline: {
                    const id = read_u16();
                    const kind: KTextBaseline = read_u8();
                    let base: CanvasTextBaseline;
                    switch (kind) {
                        case KTextBaseline.Alphabetic:
                            base = "alphabetic";
                            break;
                        case KTextBaseline.Bottom:
                            base = "bottom";
                            break;
                        case KTextBaseline.Hanging:
                            base = "hanging";
                            break;
                        case KTextBaseline.Ideographic:
                            base = "ideographic";
                            break;
                        case KTextBaseline.Middle:
                            base = "middle";
                            break;
                        case KTextBaseline.Top:
                            base = "top";
                            break;
                        default:
                            debug("unreachable KTextBaseline!", kind);
                            throw panic();
                    }
                    ctx[id].textBaseline = base;
                    break;
                }
                case CtxtOp.CompositeOperation: {
                    const id = read_u16();
                    const kind: KCompositeOperation = read_u8();
                    let operation: GlobalCompositeOperation;
                    switch (kind) {
                        case KCompositeOperation.SourceIn: {
                            operation = "source-in";
                            break;
                        }
                        case KCompositeOperation.SourceOver: {
                            operation = "source-over";
                            break;
                        }
                        case KCompositeOperation.Xor: {
                            operation = "xor";
                            break;
                        }
                        default:
                            debug("unreachable KCompositeOperation!", kind);
                            throw panic();
                    }
                    ctx[id].globalCompositeOperation = operation;
                    break;
                }
                case CtxtOp.LineCap: {
                    const id = read_u16();
                    const kind: KLineCap = read_u8();
                    let cap: CanvasLineCap;
                    switch (kind) {
                        case KLineCap.Butt: {
                            cap = "butt";
                            break;
                        }
                        case KLineCap.Round: {
                            cap = "round";
                            break;
                        }
                        case KLineCap.Square: {
                            cap = "square";
                            break;
                        }
                        default:
                            debug("unreachable KLineCap!", kind);
                            throw panic();
                    }
                    // debug("CtxtOp::LineCap", i, cap);
                    ctx[id].lineCap = cap;
                    break;
                }
                case CtxtOp.LineJoin: {
                    const id = read_u16();
                    const kind: KLineJoin = read_u8();
                    let join: CanvasLineJoin;
                    switch (kind) {
                        case KLineJoin.Round: {
                            join = "round";
                            break;
                        }
                        case KLineJoin.Bevel: {
                            join = "bevel";
                            break;
                        }
                        case KLineJoin.Miter: {
                            join = "miter";
                            break;
                        }
                        default:
                            debug("unreachable KLineJoin!", kind);
                            throw panic();
                    }
                    // debug("CtxtOp::LineJoin", i, join);
                    ctx[id].lineJoin = join;
                    break;
                }
                case CtxtOp.CursorStyle: {
                    const id = read_u16();
                    const kind: KCursorStyle = read_u8();
                    let cursor: string;
                    switch (kind) {
                        case KCursorStyle.Default: {
                            cursor = "default";
                            break;
                        }
                        case KCursorStyle.Pointer: {
                            cursor = "pointer";
                            break;
                        }
                        default:
                            debug("unreachable KCursorStyle!", kind);
                            throw panic();
                    }
                    (
                        ctx[id].canvas as HTMLCanvasElement
                    ).style.cursor = cursor;
                    break;
                }
                case CtxtOp.Print: {
                    const id = read_u16();
                    const canvas = ctx[id].canvas;
                    const dst = ref_ctx.canvas;
                    dst.width = canvas.width;
                    dst.height = canvas.height;
                    ref_ctx.drawImage(canvas, 0, 0);
                    dst.convertToBlob().then((blob) => {
                        dst.width = 1;
                        dst.height = 1;
                        const url = URL.createObjectURL(blob);
                        // const a = dom.createElement("a");
                        // a.href = url;
                        // a.download = "florr_screenshot.png";
                        // a.click();
                        // a.remove();
                        con.debug(url);
                        // URL.revokeObjectURL(url);
                    });
                    break;
                }
                case CtxtOp.CreateInput: {
                    const id = read_u8();
                    const input = document.createElement("input");
                    input.type = "text";
                    input.className = "text-input";
                    inputs[id] = input;
                    break;
                }
                case CtxtOp.AppendInput: {
                    const id = read_u8();
                    container.append(inputs[id]);
                    break;
                }
                case CtxtOp.RemoveInput: {
                    const id = read_u8();
                    inputs[id].remove();
                    inputs[id] = null;
                    break;
                }
                case CtxtOp.UpdateInput: {
                    const id = read_u8();
                    const flags = read_u8();
                    const input = inputs[id];
                    const style = input.style;
                    if (flags & InputFlag.Value) {
                        input.value = read_text();
                    }
                    if (flags & InputFlag.Position) {
                        style.left = `${read_f32()}px`;
                        style.top = `${read_f32()}px`;
                    }
                    if (flags & InputFlag.Resize) {
                        style.width = `${read_f32()}px`;
                        style.height = `${read_f32()}px`;
                    }
                    if (flags & InputFlag.FontSize) {
                        style.fontSize = `${read_f32()}px`;
                    }
                    if (flags & InputFlag.MaxLength) {
                        input.maxLength = read_u16();
                    }
                    if (flags & InputFlag.Color) {
                        style.color = read_hex();
                    }
                    break;
                }
                default:
                    debug("unreachable CtxtOp!", op);
                    throw panic();
            }
        }
    };

    const draw_card = (
        size: number,
        id: number,
        rarity: number,
        variable: number,
        is_petal: boolean,
    ): Promise<string> =>
        new Promise((ok, err) => {
            const cid = (
                is_petal ? utils_generate_petal_image : utils_generate_mob_image
            )(
                size,
                id,
                rarity,
                variable,
            );
            if (cid === -1) {
                return err(null);
            }
            const canvas = ctx[cid].canvas;
            if (canvas instanceof HTMLCanvasElement) {
                const url = canvas.toDataURL();
                remove_canvas(cid);
                return url;
            }
            canvas.convertToBlob().then(
                (blob) => {
                    remove_canvas(cid);
                    const reader = new FileReader();
                    const controller = new AbortController();
                    reader.readAsDataURL(blob);
                    reader.addEventListener("load", () => {
                        controller.abort();
                        ok(reader.result as string);
                    }, { signal: controller.signal });
                    reader.addEventListener("error", (e) => {
                        controller.abort();
                        err(e);
                    }, { signal: controller.signal });
                },
            ).catch((e) => {
                err(e);
            });
        });

    const florrio: Florr = {
        utils: {
            Path2DCompiler: import.meta.hot
                ? Path2DCompiler
                : 0xDEADBEEF as unknown as new () => CanvasPathCompiler,
            svg_to_path: (input: string, width: number, height: number) => {
                const ptr = malloc_str(input);
                const stack = utils_svg_to_path(ptr, width, height);
                return free_box_string(stack);
            },
            generate_mob_image: (
                size: number,
                id: number,
                rarity: number,
                variable: number,
            ) => {
                return draw_card(size, id, rarity, variable, false);
            },
            generate_petal_image: (
                size: number,
                id: number,
                rarity: number,
                variable: number,
            ) => {
                return draw_card(size, id, rarity, variable, true);
            },
        },
        var_float: 0.0,
    };

    const container = document.createElement("div");
    container.className = "container";
    dom.body.prepend(container);

    if (!import.meta.hot) {
        Object.freeze(florrio);
    }
    win.florrio = florrio;

    main();
};

if (import.meta.hot) {
    (async () => {
        try {
            await fn();
        } catch (e) {
            if (navigator.userAgentData?.mobile) {
                alert(e);
                return;
            }
            console.debug(e);
        }
    })();
} else {
    await fn();
}
